import { Alpine } from "alpinejs";

declare global {
	interface Window {
		gtag?: (...args: unknown[]) => void;
	}
}

Alpine.magic(
	"gaEvent",
	() =>
		(eventName: string, params: Record<string, unknown> = {}) => {
			if (typeof window.gtag === "function") {
				window.gtag("event", eventName, params);
				return;
			} else {
				console.warn(
					`Google Analytics/Tag Manager configuration unset. Event: '${eventName}' cannot be stored.`,
				);
			}
		},
);
